// extracted by mini-css-extract-plugin
export default {"container":"Avatar_container__1TS9j","img":"Avatar_img__K7ppR","title":"Avatar_title__HZws1","md":"Avatar_md__QAWVe","sm":"Avatar_sm__207vm"};